(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('@babel/core/lib/gensync-utils/fs.js')) :
  typeof define === 'function' && define.amd ? define(['@babel/core/lib/gensync-utils/fs.js'], factory) :
  (global = global || self, factory(global.fs_js));
}(this, function (fs_js) { 'use strict';

  function initAjaxFilters() {
    const MAIN_WRAPPER = `#ajax-content-wrapper`;
    const CONTENT_SELECTOR = `#ajax-content`;
    const FILTERS_SELECTOR = `#ajax-content-wrapper .menu-item > a, .bricks-pagination a.page-numbers`;
    const ANIMATION_DURATION = 300; // Duration of the animation in milliseconds

    // State
    let ajaxLoadingStatus = 'completed';

    // Elements to work with.
    const contentEl = document.querySelector(CONTENT_SELECTOR);
    const mainWrapper = document.querySelector(MAIN_WRAPPER);

    if (!contentEl || !mainWrapper) {
      // Ajax filters/areas are not found on the page.
      return;
    }

    // Setup initial content.
    setupAjaxTriggers(document);

    /*
     * Functions
     */

    function setupAjaxTriggers(rootElement) {
      // Find AJAX triggers.
      const filterTriggers = rootElement.querySelectorAll(FILTERS_SELECTOR);

      filterTriggers.forEach((link) => {
        if (link.dataset.ajaxTriggerSet) {
          // Skip if the trigger is already set
          return;
        }

        link.addEventListener('click', async (event) => {
          // Ignore click with ctrl, cmd or shift key
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
          }

          const href = link.getAttribute('href');
          if (!href) {
            console.error('No href attribute found on the clicked element');
            return;
          }

          event.preventDefault();
          let fetchedContent;

          // Start content loading in parallel with the animation, it will speed up the loading experience.
          getContent(href).then(content => fetchedContent = content);

          // Trigger loading state.
          await ajaxPerformed(link, 'started');

          try {
            if (!fetchedContent) {
              // If content is not fetched yet, let's perform the fetch again and wait for it.
              fetchedContent = await getContent(href);
            }

            await renderFetchedContent(fetchedContent, link);
          } catch (error) {
            console.error('AJAX Process Error:', error);
            await ajaxPerformed(link, 'completed');
          }
        });

        link.dataset.ajaxTriggerSet = true;
      });
    }

    function onMenuItemClick(link) {
      // Remove the active class from all menu items.
      const menuItems = mainWrapper.querySelectorAll('.current-menu-item');
      menuItems.forEach((item) => {
        item.classList.remove('current-menu-item');
      });

      // Add the active class to the clicked menu item.
      link.parentElement.classList.add('current-menu-item');
    }

    function onPaginationClick(link) {
      // Scroll to the top of the content.
      mainWrapper.scrollIntoView({behavior: 'smooth'});
    }

    async function ajaxPerformed(link, status) {
      if (ajaxLoadingStatus === status) {
        return; // Prevent multiple AJAX calls if already in the same state
      }

      ajaxLoadingStatus = status;

      // Menu items.
      if (link.parentElement.classList.contains('menu-item') && status === 'started') {
        onMenuItemClick(link);
      }

      // Pagination links.
      if (link.classList.contains('page-numbers') && status === 'started') {
        onPaginationClick(link);
      }

      {
        if (status === 'started') {
          contentEl.classList.add('ajax-loading');
          showLoadingIndicator(true);
        } else if (status === 'completed') {
          contentEl.classList.remove('ajax-loading');
          showLoadingIndicator(false);
        }

        // Wait for the animation to complete.
        await new Promise((resolve) => {
          setTimeout(resolve, ANIMATION_DURATION);
        });
      }

      // For video cards that trigger "lightbox" on click.
      if (status === 'completed' && typeof window['bricksPhotoswipe'] === 'function') {
        window['bricksPhotoswipe'](); // Re-initialize native Bricks lightbox
      }
    }

    function showLoadingIndicator(show = true) {
      if (show) {
        // Add loading indicator.
        const loadingIndicator = document.createElement('div');
        loadingIndicator.className = 'ajax-loading-indicator';

        // put it before the content element (contentEl)
        contentEl.insertAdjacentElement('beforebegin', loadingIndicator);
        return;
      }

      // Remove loading indicator.
      const loadingIndicator = document.querySelector('.ajax-loading-indicator');
      if (loadingIndicator) {
        loadingIndicator.remove();
      }
    }

    async function renderFetchedContent(content, link) {
      // Update the content.
      contentEl.innerHTML = content;

      // Re-setup AJAX triggers in the new content.
      setupAjaxTriggers(contentEl);

      // Update browser history / URL.
      history.pushState(null, '', link.getAttribute('href'));

      // Custom logic after AJAX content is loaded. (Hook)
      ajaxPerformed(link, 'completed');
    }

    async function getContent(url) {
      const content = await fetch(url);
      if (!content.ok) {
        console.error(`Failed to load content from ${url}`);
        return;
      }

      const text = await content.text();

      // Get HTML from the response
      const doc = (new DOMParser()).parseFromString(text, 'text/html');

      const fetchedContentEl = doc.querySelector(CONTENT_SELECTOR);
      if (!fetchedContentEl) {
        throw new Error(`No content found for ${url}. Probably missing required selector: ${CONTENT_SELECTOR}`);
        return;
      }

      return fetchedContentEl.innerHTML;
    }
  }

  function initHubspot($) {
    $.fn.notifyHubspot = function () {
      function doEvent(obj, name) {
        try {
          const event = new Event(name, {target: obj, bubbles: true});
          return obj ? obj.dispatchEvent(event) : false;
        } catch (e) {
          const event = document.createEvent('Event');
          event.initEvent(name, true, true);
          obj.dispatchEvent(event);
        }
      }

      $(this).each(function () {
        doEvent(this, 'change');
        doEvent(this, 'input');
        doEvent(this, 'blur');
      });

      $(this).focus();
      $(this).blur();

      return $(this);
    };
  }

  function initReportForm($) {

      // If single report page, add report title and url to hidden fields.
      if (!document.body.classList.contains('single-reports')) {
          return;
      }

      // Report form functionality
      function init({reportFormId, reportTitle, reportUrl}) {
          window.addEventListener('message', (event) => {
              if (event.data.type === 'hsFormCallback' &&
                  event.data.eventName === 'onFormReady' &&
                  event.data.id === reportFormId) {

                  const forms = document.querySelectorAll('.hs-form-' + event.data.id);
                  forms.forEach(function (form) {
                      updateHiddenField(form, 'report_title', reportTitle);
                      updateHiddenField(form, 'report_url', reportUrl);
                  });
              }
          });
      }

      function updateHiddenField(form, fieldName, value) {
          const hubspotField = form.querySelector("input[name='" + fieldName + "']");
          if (!hubspotField) {
              return;
          }

          $(hubspotField).val(value).notifyHubspot();
      }

      // Make functions globally available
      window.ReportForm = {
          init: init,
      };
  }

  function initGuideForm($) {

      // If single guides page, add gated page link to hidden fields.
      if (!document.body.classList.contains('single-guides')) {
          return;
      }

      // Guide form functionality
      function init({ guideFormId, guideTitle, gatedPageLink }) {
          window.addEventListener('message', (event) => {
              if (event.data.type === 'hsFormCallback' &&
                  event.data.id === guideFormId) {

                  if (event.data.eventName === 'onFormReady') {
                      const forms = document.querySelectorAll('.hs-form-' + event.data.id);
                      forms.forEach(function (form) {
                          updateHiddenField(form, 'report_title', guideTitle);
                          updateHiddenField(form, 'report_url', gatedPageLink);
                      });
                  }

                  // Handle form submission and redirect to gated page
                  if (event.data.eventName === 'onFormSubmit') {
                      if (gatedPageLink && gatedPageLink.trim() !== '') {
                          // Redirect to the gated page after form submission
                          window.location.href = gatedPageLink;
                      }
                  }
              }
          });
      }

      function updateHiddenField(form, fieldName, value) {
          const hubspotField = form.querySelector("input[name='" + fieldName + "']");
          if (!hubspotField) {
              return;
          }

          $(hubspotField).val(value).notifyHubspot();
      }

      // Make functions globally available
      window.GuideForm = {
          init: init,
      };
  }

  (function ($) {

    /**
     * Init
     */

    try {
      initHubspot($);
      initAjaxFilters();
      initReportForm($);
      initGuideForm($);
    } catch (err) {
      console.error(err);
    }

  })(window.jQuery);

}));
